<template>
  <div>
    <div v-if="entity.sections">
      <!-- Welcome -->
      <div class="card">
        <div class="card-header d-flex justify-content-between">
          <strong>Welcome</strong>
          <div>
            <label for="public-welcome" class="m-0 mr-1">Public</label>
            <input id="public-welcome" type="checkbox" checked disabled>
          </div>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="welcome-title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="welcome-title"
                      v-model="entity.sections.welcome.title"
                      type="text"
                      placeholder="Enter Title"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="branch-center-welcome" class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <ckeditor id="branch-center-welcome" v-model="entity.sections.welcome.description" />
                  </div>
                </div>
                <!-- Action Save -->
                <div class="mt-2">
                  <button class="btn btn-success" @click="save">
                    Save
                    <span class="btn-loader" style="display: none;" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Images Slider -->
      <div class="card">
        <div class="card-header d-flex justify-content-between">
          <strong>Images Slider</strong>
          <div>
            <label for="public-slider" class="m-0 mr-1">Public</label>
            <input id="public-slider" v-model="entity.sections.images_slider.show" type="checkbox">
          </div>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="include-slider" class="col-md-2">Show Photos Slider</label>
                  <div class="col-md-10">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <input id="include-slider" v-model="entity.sections.images_slider.show" type="checkbox">
                      </div>
                      <div v-show="entity.sections.images_slider.show" class="col-md-12 mt-2">
                        <dropzone
                          v-if="dropzoneOptions"
                          id="files-uploader"
                          ref="dropzone"
                          :options="dropzoneOptions"
                          :destroy-dropzone="false"
                          @vdropzone-file-added="fileUploadedSuccess"
                          @vdropzone-removed-file="fileRemoved"
                        />
                        <div v-else>Dropzone can't work without upload url.</div>
                        <!-- Select Files Button -->
                        <div class="mt-3">
                          <button class="btn btn-success" @click.prevent="$refs.dropzone.dropzone.element.click()">
                            Select Images
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Action Save -->
                <div class="mt-2">
                  <button class="btn btn-success" @click="save">
                    Save
                    <span class="btn-loader" style="display: none;" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- About -->
      <div class="card">
        <div class="card-header d-flex justify-content-between">
          <strong>About</strong>
          <div>
            <label for="public-about" class="m-0 mr-1">Public</label>
            <input id="public-about" type="checkbox" checked disabled>
          </div>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="about-title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="about-title"
                      v-model="entity.sections.about.title"
                      type="text"
                      placeholder="Enter Title"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="branch-center-about" class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <ckeditor id="branch-center-about" v-model="entity.sections.about.description" />
                  </div>
                </div>
                <!-- Action Save -->
                <div class="mt-2">
                  <button class="btn btn-success" @click="save">
                    Save
                    <span class="btn-loader" style="display: none;" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Announcements -->
      <div class="card">
        <div class="card-header d-flex justify-content-between">
          <strong>Announcements</strong>
          <div>
            <label for="public-announcements" class="m-0 mr-1">Public</label>
            <input id="public-announcements" v-model="entity.sections.announcements.show" type="checkbox">
          </div>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="announcements-title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="announcements-title"
                      v-model="entity.sections.announcements.title"
                      type="text"
                      placeholder="Enter Title"
                      class="form-control"
                    >
                  </div>
                </div>
                <!-- Action Save -->
                <div class="mt-2">
                  <button class="btn btn-success" @click="save">
                    Save
                    <span class="btn-loader" style="display: none;" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- News Notes -->
      <div class="card">
        <div class="card-header d-flex justify-content-between">
          <strong>News Notes</strong>
          <div>
            <label for="public-news-notes" class="m-0 mr-1">Public</label>
            <input id="public-news-notes" v-model="entity.sections.news_notes.show" type="checkbox">
          </div>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="news_notes-title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="news_notes-title"
                      v-model="entity.sections.news_notes.title"
                      type="text"
                      placeholder="Enter Title"
                      class="form-control"
                    >
                  </div>
                </div>
                <!-- Action Save -->
                <div class="mt-2">
                  <button class="btn btn-success" @click="save">
                    Save
                    <span class="btn-loader" style="display: none;" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Contact -->
      <div class="card">
        <div class="card-header d-flex justify-content-between">
          <strong>Contact</strong>
          <div>
            <label for="public-contact" class="m-0 mr-1">Public</label>
            <input id="public-contact" v-model="entity.sections.contact.show" type="checkbox">
          </div>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="contact-title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="contact-title"
                      v-model="entity.sections.contact.title"
                      type="text"
                      placeholder="Enter Title"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="branch-center-contact" class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <ckeditor id="branch-center-contact" v-model="entity.sections.contact.description" />
                  </div>
                </div>
                <!-- Action Save -->
                <div class="mt-2">
                  <button class="btn btn-success" @click="save">
                    Save
                    <span class="btn-loader" style="display: none;" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Location -->
      <div class="card">
        <div class="card-header d-flex justify-content-between">
          <strong>Location</strong>
          <div>
            <label for="public-location" class="m-0 mr-1">Public</label>
            <input id="public-location" v-model="entity.sections.location.show" type="checkbox">
          </div>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="googleLink" class="col-md-2">Name of Institution</label>
                  <div class="col-md-10">
                    <input
                      id="googleLink"
                      v-model="entity.sections.location.title"
                      type="text"
                      placeholder="Enter Title"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-2">Geocode</label>
                  <div class="col-md-5" style="margin-bottom: 1rem;">
                    <input v-model="entity.location.lat" type="text" placeholder="Enter latitude" class="form-control">
                  </div>
                  <div class="col-md-5">
                    <input v-model="entity.location.lng" type="text" placeholder="Enter longitude" class="form-control">
                  </div>
                  <div class="col-md-10 offset-md-2">
                    <gmap-map
                      v-if="entity.location"
                      style="width: 100%; height:350px; margin-top: 20px;"
                      :center="sourceMapData.center"
                      :zoom="sourceMapData.zoom"
                      @click="mapClick"
                    >
                      <gmap-marker v-if="entity.location.lat && entity.location.lng" :position="entityMapCenter" />
                    </gmap-map>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="include-slider" class="col-md-2">Show Contact Info</label>
                  <div class="col-md-10">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <input
                          id="show-contact-info"
                          v-model="entity.sections.location.show_contact_info"
                          type="checkbox"
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Action Save -->
                <div class="mt-2">
                  <button class="btn btn-success" @click="save">
                    Save
                    <span class="btn-loader" style="display: none;" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="card">
        <div class="card-header d-flex justify-content-between">
          <strong>There are no sections for this branch yet.</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.css';
import { uploadStatus } from '@/helpers/constants';
// Mixins
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';
import CommonPageMixin from '@/mixins/CommonPageMixin';
import config from '../../../config';

const { SUCCESS } = uploadStatus;
export default {
  name: 'CenterPage',
  components: {
    dropzone: Dropzone,
  },
  mixins: [DefaultOptionsRequests, CommonPageMixin],
  props: {
    entity: {
      type: Object,
      default: () => {},
    },
    source: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 2048,
      },
      files: [],
      uploadedFiles: [],
      toDeleteFiles: [],
    };
  },
  computed: {
    dropzoneOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.$store.state.user.accessToken.access_token}`,
          Accept: 'application/json',
        },
        method: 'POST',
        paramName: 'media',
        url: `${this.$config.app_api.host}${this.$config.app_api.prefix}branch_office/${this.$route.params.id}/file`,
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'image/*',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?',
      };
    },
    uploadingFiles() {
      const getUploadings = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadings) {
        return [];
      }
      return getUploadings(this.$route.params.id, 'branch_office');
    },
    sourceMapData() {
      if (this.entity.location === undefined
        || this.entity.location.lat == null
        || this.entity.location.lng == null
      ) {
        return {
          center: {
            lat: 0,
            lng: 0,
          },
          zoom: 2,
        };
      }
      return {
        center: {
          lat: _.toNumber(this.entity.location.lat),
          lng: _.toNumber(this.entity.location.lng),
        },
        zoom: 13,
      };
    },
    entityMapCenter() {
      if (this.entity.location === undefined
        || this.entity.location.lat == null
        || this.entity.location.lng == null
      ) {
        return {
          lat: 0,
          lng: 0,
        };
      }
      return {
        lat: _.toNumber(this.entity.location.lat),
        lng: _.toNumber(this.entity.location.lng),
      };
    },
  },
  watch: {
    uploadingFiles: {
      handler(val) {
        this.uploadedFiles = val.filter(file => file.status === SUCCESS).map(file => file.file);
        const { dropzone } = this.$refs;
        if (dropzone) {
          this.uploadedFiles.forEach(file => dropzone.removeFile(file));
          this.uploadedFiles.forEach((file) => {
            dropzone.manuallyAddFile(file, '/');
            $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src',
              'static/img/file-thumb.jpg');
          });
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getSource();
  },
  methods: {
    getAnnouncements() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}announcements`, {
        params: {
          with: [
            'pdf',
            'cover',
            'branch',
          ],
        },
      })
        .then((response) => {
          console.log(response.data);
          const newResponse = _.cloneDeep(response.data);
          this.source = newResponse;
          this.entity = _.cloneDeep(newResponse);
        })
        .catch((error) => {
          console.error(error);
          this.$store.dispatch('notifications/setHttpError', {
            error,
            text: 'Error in getting data request',
          });
        });
    },
    getNewsNotes() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}news-notes`, {
        params: {
          with: [
            'pdf',
            'cover',
            'branch',
          ],
        },
      })
        .then((response) => {
          console.log(response.data);
          const newResponse = _.cloneDeep(response.data);
          this.source = newResponse;
          this.entity = _.cloneDeep(newResponse);
        })
        .catch((error) => {
          console.error(error);
          this.$store.dispatch('notifications/setHttpError', {
            error,
            text: 'Error in getting data request',
          });
        });
    },
    getSource() {
      if (this.entity.images) {
        this.manuallyAddFiles();
      }
    },
    manuallyAddFiles() {
      for (let i = 0; i < this.entity.images.length; i += 1) {
        const file = {
          file: {
            name: this.entity.images[i].file_name,
            size: this.entity.images[i].size,
          },
          url: this.entity.images[i].public_url,
        };
        this.$refs.dropzone.manuallyAddFile(file.file, file.url);
        if (!this.entity.images[i].mime_type.match(/image.*/)) {
          $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
        }
      }
    },
    fileUploadedSuccess(file) {
      this.files.push(file);
    },
    fileRemoved(file) {
      const fileIndex = _.findIndex(this.entity.images, item => item.file_name === file.name && item.size === file
        .size);
      if (fileIndex === -1) return;
      const fileId = this.entity.images[fileIndex].id;
      this.toDeleteFiles.push(fileId);
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('domain', this.entity.domain);
      postFormData.append('type', this.entity.type);
      postFormData.append('sections', JSON.stringify(this.entity.sections));
      postFormData.append('boxes', JSON.stringify(this.entity.boxes));
      postFormData.append('local_institution', this.entity.local_institution ? this.entity.local_institution : '');
      postFormData.append('library', this.entity.library ? this.entity.library : '');
      if (this.entity.description) {
        postFormData.append('description', this.entity.description);
      }
      postFormData.append('published', this.entity.published || false);
      postFormData.append('address', JSON.stringify(this.entity.address.address));
      postFormData.append('mail_address', JSON.stringify(this.entity.address.mail_address));
      postFormData.append('alt_address', JSON.stringify(this.entity.address.alt_address));
      postFormData.append('contacts', JSON.stringify(this.entity.contacts));
      postFormData.append('location', JSON.stringify(this.entity.location));
      postFormData.append('sections', JSON.stringify(this.entity.sections));
      postFormData.append('boxes', JSON.stringify(this.entity.boxes));
      return this.$apiHttp.post(`${this.$config.app_api.prefix}branch-offices/${this.$route.params.id}`,
        postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      const files = this.files.filter(file => !file.manuallyAdded);
      const {
        prefix,
        host,
      } = this.$config.app_api;
      const {
        acceptedFiles,
      } = this.dropzoneOptions;
      const vm = this;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
      if (this.toDeleteFiles.length) {
        for (let i = 0; i < this.toDeleteFiles.length; i += 1) {
          this.$apiHttp.delete(
            // eslint-disable-next-line max-len
            `${this.$config.app_api.host}${this.$config.app_api.prefix}branch-offices/${this.$route.params.id}/images/${this.toDeleteFiles[i]}`,
          )
            // eslint-disable-next-line no-loop-func
            .then(() => {
              this.entity.files.splice(i, 1);
            }).catch((error) => {
              console.error('error in delete file in site page request - ', error);
            });
        }
      }
      this.saveRequest().then(() => {
        $('.btn-success .btn-loader').hide();
        this.$store.commit('notifications/setSuccessNotification', 'Success!');
        $('.saving-alerts .alert-success').show();
        if (files && files.length > 0) {
          this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: this.$route.params.id,
            files: [...files],
            token,
            acceptedFiles,
            contentType: 'branch_office',
          });
          vm.files = [];
        }
      }).catch((error) => {
        $('.btn-success .btn-loader').hide();
        this.$store.commit('notifications/setDangerNotification', 'Error!');
        console.error('Error in update branch office query', error);
      });
    },
    mapClick(event) {
      this.entity.location.lat = event.latLng.lat();
      this.entity.location.lng = event.latLng.lng();
    },
  },
};
</script>



// WEBPACK FOOTER //
// CenterPage.vue?7d80370c